exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-permission-all-section .list-group {\n  margin-bottom: 10px !important;\n  padding-left: 0; }\n\n.user-permission-all-section .panel-group {\n  margin-bottom: 10px !important; }\n\n.user-permission-all-section .table-bordered > tbody > tr > td {\n  vertical-align: none !important;\n  border-top: 1px solid #ddd !important;\n  border: none  !important; }\n\n.user-permission-all-section .error-msg-section {\n  margin: 8px;\n  padding: 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/user_permission_report/all/user_permission_report.all.scss
// module id = 1177
// module chunks = 1